module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Sturz.f06ca738.jpg";